//@ts-check
/*
  This script is to be loaded at the <head> to supply logic 
  to allow to certain components to be initialised upon render immediately or with code splitting
  as compared to waiting DOMContentLoaded event, 
  also fixing interactivity at CMS admin page builder
*/
import { initContext, initComponent } from "./utils/init"

// Widgets to load immediately during render
import './widgets/TabProperties'
import './widgets/AccordionWithImage'


/**
 * Widgets to load with code splitting to reduce bundle size
 * @param {string} type
 */
async function importCodeSplitAsync(kind, type) {
  switch (type) {
    case "CarouselWithThumbnails": return import(`./widgets/CarouselWithThumbnails`)
    case "MilestoneWidget": return import(`./widgets/MilestoneWidget`)
    case "HomepageCarouselBanner": return import('./widgets/HomepageCarouselBanner')
    case "Carousel3Cards": return import('./widgets/Carousel3Cards')
    case "ImageCarouselWidgetProperties": return import('./widgets/ImageCarouselWidgetProperties')
    case "MediaCarousel": return import('./widgets/MediaCarousel')
    case "CarouselCard": return import("./widgets/CarouselCard")
    case "StationTabProperties": return import("./widgets/StationTabProperties")
    case "FormBuilderForm": return import("./widgets/FormBuilderForm")
    case "LatestNewsWidget": return import("./widgets/LatestNewsWidget")
    default:
      console.warn("[Entry]", "Undeclared code split async import", type)
      break;
  }
}

// console.log("[Entry]", "loaded")

document.addEventListener("viewMount", (/**@type {CustomEventInit}*/e) => {
  /** @type {HTMLElement} */
  const element = e.detail

  const componentType =  /** @type {string} */ (element.getAttribute("widget-type") ?? element.dataset.componentType)

  if (componentType) {
    console.log("[Entry]", "viewmount widget", componentType)
    loadType(componentType, element)
  }
  else {
    console.warn("[Entry]", "Unknown component", element)
  }

})

/**
 * @param {string} type
 * @param {HTMLElement} element
 */
async function loadType(type, element) {
  if (!initContext.initialisers.has(type)) {
    console.log("[Entry]", "async import", type)
    await importCodeSplitAsync("widget", type)
  }
  const callback = initContext.initialisers.get(type)

  if (callback) {
    initComponent(type, element, callback)
  }
  else {
    console.warn("[Entry]", type, "Missing Init")
  }
}
